import React from 'react';
import classNames from 'classnames/bind';
import styles from './BlogDetail.module.scss';
import moment from 'moment';
import useSeo from 'hooks/useSeo';

const cx = classNames.bind(styles);

const getHardwareClass = (hardware) => {
  if (!hardware) return 'tag_red';
  const hw = hardware.trim();
  if (hw.includes('LED') && (hw.includes('빔') || hw.includes('프로젝터'))) {
    return 'tag_purple';
  }
  if (hw.includes('LED')) {
    return 'tag_cyan';
  }
  if (hw.includes('빔') || hw.includes('프로젝터')) {
    return 'tag_red';
  }
  return 'tag_red';
};

export default function BlogDetail({ data, handleGoList }) {
  const { title, content, createdAt, thumbnailImageUrl, hardware, industry } =
    data || {};

  // SEO 적용
  const thumbnailAlt = title ? `${title} - 게시글 썸네일` : '게시글 썸네일';
  const plainText = content
    ? content.replace(/<[^>]+>/g, '').slice(0, 150)
    : '';

  useSeo(title, plainText, thumbnailImageUrl);

  if (!data) return null;

  return (
    <div className={cx('container')}>
      <div className={cx('inner')}>
        <article className={cx('article')}>
          <header className={cx('header')}>
            <div className={cx('tags')}>
              {hardware && (
                <span className={cx('tag', getHardwareClass(hardware))}>
                  {hardware}
                </span>
              )}
              {industry && (
                <span className={cx('tag', 'tag_gray')}>{industry}</span>
              )}
            </div>
            <h1 className={cx('title')}>{title}</h1>
            <div className={cx('meta')}>
              <span className={cx('date')}>
                {moment(createdAt).format('YYYY. MM. DD')}
              </span>
            </div>
          </header>

          <div className={cx('content_box')}>
            <div
              className={cx('content')}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>

          <div className={cx('btn_box')}>
            <button className={cx('btn_list')} onClick={handleGoList}>
              목록으로
            </button>
          </div>
        </article>
      </div>
    </div>
  );
}
